import LinearProgress from '@material-ui/core/LinearProgress';
import React, { FunctionComponent } from 'react';

import {
	Theme,
	WithStyles,
	createStyles,
	withStyles,
} from '@material-ui/core/styles';

const styles = (theme: Theme) =>
	createStyles({
		root: {
			position: 'absolute',
			width: '100%',
			backgroundColor: 'transparent',
			textAlign: 'center',
		},
		top: {
			left: '0px',
			bottom: '70px',
			width: '100vw',
			position: 'fixed',
		},
		bar: {
			backgroundColor: theme.palette.primary.main,
		},
	});

interface Props extends WithStyles<typeof styles> {
	showSpinner: boolean;
	isTopView?: boolean;
}

const Loading: FunctionComponent<Props> = (props) => {
	const classesToImport = props.isTopView||false ? `${props.classes.root} ${props.classes.top}` : props.classes.root;

	return <LinearProgress
		classes={{
			root: classesToImport,
			bar: props.classes.bar,
		}}

		color="primary"
	/>
};

export default withStyles(styles)(Loading);
